export const SAVED_VIEW_QUERY_NAME = 'saved_view' as const;
